<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap>
              <v-flex xs12>
                <h3>Strom spolupracovníků</h3>
              </v-flex>
            </v-layout>
            <!-- <v-layout row wrap>
              <v-flex grow>
                <div class="collaborator">
                  <strong class="fs-12">{{me.cele_jmeno}}</strong>
                </div>
              </v-flex>
              <v-flex shrink>
                <obdobi hide-details class="ml-2 mt-1" v-model="obdobi"></obdobi>
              </v-flex>
            </v-layout> -->
            <v-layout row wrap align-center>
              <v-flex shrink>
                <v-radio-group v-model="certifikace" row>
                  <v-radio label="Vše" :value="0"></v-radio>
                  <v-radio label="Pouze certifikované" :value="1"></v-radio>
                  <v-radio label="Pouze necertifikované" :value="2"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex shrink>
                <v-select
                  label="Pozice v kariéře"
                  :items="poziceItems"
                  v-model="pozice"
                  clearable class="mx-3"
                ></v-select>
              </v-flex>
              <v-flex shrink>
                <v-checkbox v-model="smazano" label="Zobrazit smazané" :value="true"></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="items.length > 0">
              <v-flex xs12>
                <spolupracovnici-podrizeni :items="items"></spolupracovnici-podrizeni>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      counter: 0,
      loadingTable: false,
      search: "",
      items: [],
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nazev_osoby",
        totalItems: 0,
        pages: 0,
        detail: false
      },
      obdobi: null,
      certifikace: 0,
      poziceItems: [ "I.", "II.", "III.", "IV.", "V.", "VI.", "VII." ],
      pozice: null,
      smazano: false
    }
  },
  watch: {
  	pagination: {
  		handler: function(newValue) {
        if (!this.loadingTable)
  			   this.load();
  		},
  		deep: true
  	},
    osoba () {
      this.load();
    },
    obdobi () {
      this.load();
    },
    certifikace () {
      this.load();
    },
    pozice () {
      this.load();
    },
    smazano () {
      this.load();
    }
  },
  computed: {
    me: function() {
      return window.$me;
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load (f) {
      this.counter++;
      this.loadingTable = true;
      this.items = [];
      window.API.post("prehledy/spolupracovnici/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter,
        certifikace: this.certifikace,
        pozice: this.pozice,
        smazano: this.smazano
        //obdobi: this.obdobi
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items = body.data;
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Prehledy/PrehledSpolupracovniku.vue